// extracted by mini-css-extract-plugin
export default {"popover":"FileUploadPopover_popover__Y61aK","isHidden":"FileUploadPopover_isHidden__NCAFZ","loader":"FileUploadPopover_loader__FgvBs"};